import moment, { Moment } from "moment";
import { AfterViewInit, Component, OnDestroy, OnInit } from "@angular/core";
import { BaseComponent } from "../../base/base.component";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { LangChangeEvent, TranslateService } from "@ngx-translate/core";
import {
  Committee,
  CommitteesGQL,
  GetUnitiesGQL,
  GetUsersGQL,
  Idea,
  SearchAllIdeasGQL,
  SearchIdeaInput,
  Unity,
  User,
} from "../../../generated/graphql";
import { QueryRef } from "apollo-angular";
import { ExcelService } from "../../service/excel.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { UserService } from "../../service/user.service";
import {
  GetAuthorsKaizenGQL,
  IdeaKaizen,
  IdeaPageKaizen,
  RemoveIdeaKaizenGQL,
  SearchAllIdeasKaizenGQL,
  SearchAllIdeasKaizenQuery,
} from "src/generated/graphql/ideaKaizen.graphql";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { IFrameFilterInput } from "./interfaces/my-list-kaizen.interfaces";
declare var $: any;

interface IStatus {
  id: string;
  name: string;
}

interface IDropSettings {
  singleSelection: boolean;
  idField: string;
  textField: string;
  selectAllText: string;
  unSelectAllText: string;
  itemsShowLimit: number;
  allowSearchFilter: boolean;
}

@Component({
  selector: "app-my-list-kazien",
  templateUrl: "./my-list-kaizen.component.html",
  styleUrls: ["./my-list-kaizen.component.scss"],
})
export class MyListKaizenComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {
  user: User = new User();
  private destroy$ = new Subject<void>();
  // filtro restaurado de 'filterIdeaKaizen' (null quando não há filtro salvo)
  private restoredFilter: SearchIdeaInput | null = null;
  // ids salvos de Autor aguardando as opções carregarem. Necessário porque o
  // ng-multiselect-dropdown (writeValue) emite ngModelChange([]) na inicialização, o que zera
  // os ids em searchIdeaInput antes de a lista chegar.
  private pendingDropIds: { authorName?: string[] } = {};
  keyword: string = "";
  status: string[];
  checked: boolean = true;
  searchIdeaInput: SearchIdeaInput = new SearchIdeaInput();

  getIdeasKaizenSearchQuery: QueryRef<SearchAllIdeasKaizenQuery>;

  ideasPageKaizen: IdeaPageKaizen = new IdeaPageKaizen();
  ideasKaizenFormatted: IdeaKaizen[];
  committess: Committee[] = [];
  unities: Unity[] = [];
  committee: Committee[] = [];
  users: User[] = [];
  authors: Idea[] = [];
  author: IdeaKaizen[] = [];

  listStatusDrop: IStatus[] = [];

  listStatusItems: IStatus[] = [];

  dropSettings: IDropSettings = {
    singleSelection: false,
    idField: "id",
    textField: "name",
    selectAllText: "Marcar todos",
    unSelectAllText: "Desmarcar todos",
    itemsShowLimit: 3,
    allowSearchFilter: true,
  };

  dropSettingsAuthor: IDropSettings = {
    singleSelection: false,
    idField: "authorName",
    textField: "authorName",
    selectAllText: "Marcar todos",
    unSelectAllText: "Desmarcar todos",
    itemsShowLimit: 3,
    allowSearchFilter: true,
  };

  btnUnity: boolean;
  btnFrameKaizen: boolean;
  frameKaizen: string;
  listFrameKaizen: IFrameFilterInput[];

  deleteIdea: boolean;

  constructor(
    public router: Router,
    public loading: NgxSpinnerService,
    public translate: TranslateService,
    public searchAllIdeasGQL: SearchAllIdeasGQL,
    public searchAllIdeasKaizenGQL: SearchAllIdeasKaizenGQL,
    public getUnitiesGQL: GetUnitiesGQL,
    public committeesGQL: CommitteesGQL,
    public removeIdeiaKaizenGQL: RemoveIdeaKaizenGQL,
    public getUsersGQL: GetUsersGQL,
    public getAuthorsKaizenGQL: GetAuthorsKaizenGQL,
    public userService: UserService,
    public excelService: ExcelService,
    private http: HttpClient,
  ) {
    super(router, loading, translate);

    // troca de idioma só retraduz as opções; o filtro salvo é mantido
    this.translate.onLangChange
      .pipe(takeUntil(this.destroy$))
      .subscribe((event: LangChangeEvent) => {
        $(() => {
          this.createStatusArray();
          this.syncStatusItems(this.listStatusItems.map((s) => s.id));
        });
      });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.setDatePicker("picker-period", (start: Moment, end: Moment) => {
        this.searchIdeaInput.start = start.utcOffset(0, true).format();
        this.searchIdeaInput.end = end.utcOffset(0, true).format();
      });
      // exibe no campo o mesmo período salvo que a query usou (em vez do padrão de 30 dias)
      if (this.restoredFilter?.start && this.restoredFilter?.end) {
        const picker = $(".picker-period").data("daterangepicker");
        picker?.setStartDate(moment.utc(this.restoredFilter.start));
        picker?.setEndDate(moment.utc(this.restoredFilter.end));
      }
    }, 500);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit() {
    this.userService.user.subscribe({
      next: (data: User) => {
        this.user = data;
        this.userProfile();
      },
      error: (err) => super.onError(err),
    });
    this.handlerFilterModel();
    this.createStatusArray();
    this.syncStatusItems();
    this.searchIdeaInput.order ?? "name";
    this.actionIdea();
    this.getUnities();
    this.getFramesKaizen();
    this.getAuthors();
  }

  getFramesKaizen() {
    this.http.get(`${environment.base_url}/frame`).subscribe(
      (response: IFrameFilterInput[]) => {
        this.listFrameKaizen = response.map((item) => item);
      },
      (error) => {},
    );
  }

  createStatusArray() {
    this.listStatusDrop = [
      {
        id: "received",
        name: this.changeName(this.translate.instant("received")),
      },
      {
        id: "analysis",
        name: this.changeName(this.translate.instant("analysis")),
      },
      {
        id: "approved",
        name: this.changeName(this.translate.instant("approved")),
      },
      { id: "approved_award", name: this.translate.instant("approved_award") },
      { id: "denied", name: this.changeName(this.translate.instant("denied")) },
      { id: "denial", name: this.changeName(this.translate.instant("denial")) },
      {
        id: "awarded",
        name: this.changeName(this.translate.instant("awarded")),
      },
      {
        id: "converted",
        name: this.changeName(this.translate.instant("converted")),
      },
    ];
  }

  changeName(name: string) {
    switch (name) {
      case "Análise":
        return "A fazer";
      case "Ideia Pontuada":
        return "Em Execução";
      case "Aprovada":
        return "Aprovada";
      case "Premiada":
        return "Concluida";
      case "Reprovada":
        return "Reprovada";
      case "Reprovar":
        return "Reprovar";
      case "Recebida":
        return "Recebida";
      case "Convertido":
        return "Convertido";
      default:
        return "";
    }
  }

  getUnities() {
    this.getUnitiesGQL.watch().valueChanges.subscribe(({ data }) => {
      this.unities = data.getUnities as Array<Unity>;
    });
  }

  getAuthors() {
    this.getAuthorsKaizenGQL.watch().valueChanges.subscribe(
      ({ data }) => {
        this.author = data.getAuthorsKaizen as Array<IdeaKaizen>;
        const names = this.takeDropIds("authorName", (this.authors || []).map((a) => a.authorName));
        this.authors = (this.author as unknown as Idea[]).filter(
          (a, i, arr) =>
            names.includes(a.authorName) &&
            arr.findIndex((x) => x.authorName === a.authorName) === i,
        );
      },
      (error) => {
        super.onError(error);
      },
    );
  }

  async actionIdea() {
    this.loading.show();
    // usa a página restaurada do filtro salvo; sem filtro salvo, começa na 1
    this.searchIdeaInput.page = this.searchIdeaInput.page || 1;
    this.getIdeasKaizenSearchQuery = this.searchAllIdeasKaizenGQL.watch({
      input: this.searchIdeaInput,
    });
    this.getIdeasKaizenSearchQuery.valueChanges.subscribe(({ data }) => {
      this.ideasKaizenFormatted = data.searchAllIdeaKaizen.ideas.map((item) => {
        const arrStr = item.code.split("-");

        return {
          ...item,
          code: `${arrStr[0]} - ${arrStr[1].toString().padStart(4, "0")}`,
        };
      });
      this.ideasPageKaizen = {
        ...data.searchAllIdeaKaizen,
        ideas: this.ideasKaizenFormatted,
      };
      this.loading.hide();
    });
  }

  actionSearch(pageChanged: boolean = false) {
    this.searchIdeaInput.status = [];
    this.searchIdeaInput.frame = this.frameKaizen;

    this.listStatusItems.forEach((e) => {
      this.searchIdeaInput.status.push(e.id);
    });

    // nova busca volta para a página 1; troca de página mantém a escolhida
    if (!pageChanged) {
      this.searchIdeaInput.page = 1;
    }
    super.setFilterLocal("filterIdeaKaizen", this.searchIdeaInput);

    this.loading.show();
    this.getIdeasKaizenSearchQuery
      .refetch({ input: this.searchIdeaInput })
      .finally(() => this.loading.hide());
  }

  actionExcel() {
    this.excelService.getExcelIdeaKaizen(this.searchIdeaInput).subscribe({
      next: (data) => {
        this.downloadHandlerFile(data);
      },
      error: (err) => super.onError(err),
    });
  }

  pageChanged(event: number) {
    this.searchIdeaInput.page = event;
    this.actionSearch(true);
  }

  downloadHandlerFile(e) {
    const blob = new Blob([e], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    $("#btnDownload").attr("href", url);
    setTimeout(() => {
      $("#btnDownload")[0].click();
    });
  }

  cleanFilter() {
    this.searchIdeaInput.keyword = undefined;
    this.searchIdeaInput.unityId = undefined;
    this.searchIdeaInput.frame = undefined;
    this.keyword = undefined;
    this.frameKaizen = undefined;
    this.searchIdeaInput.status = [];
    this.authors = [];
    this.listStatusItems = [];
    this.searchIdeaInput.authorName = undefined;
    this.searchIdeaInput.start = moment().subtract(30, "days");
    this.searchIdeaInput.end = moment();
    this.setDatePicker("picker-period", (start: Moment, end: Moment) => {
      this.searchIdeaInput.start = start.utcOffset(-30, true).format();
      this.searchIdeaInput.end = end.utcOffset(0, true).format();
    });
    this.pendingDropIds = {};

    this.actionSearch();
    // actionSearch grava o filtro; a limpeza remove a chave em seguida
    localStorage.removeItem("filterIdeaKaizen");
  }

  validateUser() {
    if (this.user.role !== "admin") {
      return false;
    }
    return true;
  }

  private handlerFilterModel() {
    const localFilter = super.getFilterLocal("filterIdeaKaizen");
    const modelFormat = JSON.stringify(this.searchIdeaInput);
    if (!this.isNullOrUndefined(localFilter) && modelFormat !== localFilter) {
      // o período é aplicado ao date picker no ngAfterViewInit (aqui o picker ainda não existe);
      // Status é remarcado em syncStatusItems e Autor quando as opções carregam
      this.searchIdeaInput = JSON.parse(localFilter);
      this.restoredFilter = JSON.parse(localFilter);
      // o select de Quadro usa frameKaizen; sem isso o actionSearch apagaria o frame salvo
      this.frameKaizen = this.restoredFilter.frame;
      this.pendingDropIds = { authorName: this.restoredFilter.authorName };
    }
  }

  // remarca o dropdown de Status com os rótulos atuais (padrão: ids salvos em searchIdeaInput.status)
  private syncStatusItems(ids: string[] = this.searchIdeaInput.status || []) {
    this.listStatusItems = this.listStatusDrop.filter((s) => ids.includes(s.id));
  }

  // ids a remarcar num dropdown: os restaurados (uma única vez) ou, depois, a seleção atual do
  // próprio dropdown (searchIdeaInput pode ter sido zerado pelo ngModelChange([]) da inicialização)
  private takeDropIds(key: "authorName", current: string[]): string[] {
    const ids = this.pendingDropIds[key] ?? current;
    delete this.pendingDropIds[key];
    return ids;
  }

  userProfile() {
    switch (this.user.role) {
      case "admin":
        this.btnUnity = true;
        this.btnFrameKaizen = true;
        this.deleteIdea = true;
        break;
      case "user":
        this.btnUnity = true;
        this.btnFrameKaizen = true;
        this.deleteIdea = false;
        break;
      case "corporate-manager":
        this.btnUnity = true;
        this.btnFrameKaizen = true;
        this.deleteIdea = true;
        break;
      case "local-manager":
        this.btnUnity = true;
        this.btnFrameKaizen = true;
        this.deleteIdea = false;
        break;
      case "committee-member":
        this.btnUnity = false;
        this.btnFrameKaizen = false;
        this.deleteIdea = false;
        break;
    }
  }

  onSelectDropAuthors($event: [Idea]) {
    this.searchIdeaInput.authorName = $event.map((value) => value.authorName);
  }

  onDelete(id: string) {
    super.confirmMessage(
      this.translate.instant("attention"),
      `${this.translate.instant("questionExcludeIdeaKaizen")} ${this.translate.instant("questionExcludePontuationIdeaKaizen")}`,
      () => {
        this.loading.show();
        this.removeIdeiaKaizenGQL.mutate({ id: id }).subscribe(
          () => {
            this.getIdeasKaizenSearchQuery.refetch({
              input: this.searchIdeaInput,
            });
            this.loading.hide();
          },
          (err) => super.onError(err),
        );
      },
    );
  }
}
